import { ResearchItem } from "../../../api/research.types";
import { ResearchesAllAction } from "./researches.all.types";

export const researchesAllRequestAction = (): ResearchesAllAction => ({ type: 'RESEARCHES_ALL_REQUEST' })
export const researchesAllSuccessAction = (researches: ResearchItem[]): ResearchesAllAction => ({ type: 'RESEARCHES_ALL_SUCCESS', params: researches })
export const researchesAllFailureAction = (error?: any): ResearchesAllAction => ({ type: 'RESEARCHES_ALL_FAILURE', params: error })